<div
  class="c__main"
  sdIsCollapsible
  (isOpenChange)="toggle()"
  [(isOpen)]="isCardOpened"
  [collapsiblePanel]="collapsibleElement"
  [action]="actionElement"
>
  <div class="c__wrapper" (click)="toggle()">
    <sd-title #titleEl
      [id]="'titleCard' + idCard"
      [titleLevel]="titleLevel"
      [customClass]="(storeInfo?.type | lowercase) === storeType.store ? 'is-store c__title is-body-s is-bold' : 'c__title is-body-s is-bold'"
    >
      @if ((storeInfo?.type | lowercase) === storeType.store && !isHob ) {
        <sd-icon
          name="icon-brand-xs"
          [size]="iconSize.small"
          class="c__logo"
          placeholder="Brand icon"
        />
      }
      @if (storeInfo?.isFavorite) {
        <sd-icon
          name="icon-star-filled"
          [attr.data-color]="'primary-base'"
          [size]="iconSize.small"
          placeholder="Favorite Store Icon"
        />
      }
      <span>{{ storeInfo?.name }}</span>
    </sd-title>
    @if (hasCloseButton) {
      <button sd-button-icon
        type="button"
        [theme]="themesEnum.dark"
        [size]="iconSize.small"
        icon="icon-cross"
        [buttonIconTitle]="'forms.a11y.formInput.button.name' | translate"
        (click)="onClose()"
      ></button>
    }
    <p class="c__subtitle is-overline">
      @if (hasProduct || storeInfo?.status) {
        <span class="c__status">
          <span
            class="c--pellet is-small"
            [attr.data-background]="hasProduct ? (storeInfo?.productAvailability ? 'success-base' : 'error-base') : (storeInfo?.status ? 'success-base' : 'error-base')"
          ></span>
          {{ (hasProduct ? (storeInfo?.productAvailability ? 'product.stock.inStock' : 'product.stock.outOfStock') : (storeInfo?.status ? 'storelocator.store.open' : 'storelocator.store.close')) | translate }}
        </span>
      }
      @if (storeInfo?.formattedDistance) {
        <span class="c__distance">
          {{ storeInfo?.formattedDistance }}
        </span>
      }
    </p>

    <address class="c__content">
      <sd-html innerClass="c__address is-caption is-wysiwyg" [html]="storeInfo?.address" />
      @if (pickup && storeInfo?.openingHours) {
        <button sd-button-icon
          #actionPickup
          type="button"
          [brand]="brand"
          [attr.aria-describedby]="'titleCard' + idCard"
          [attr.aria-controls]="isCardOpened"
          [buttonIconTitle]="'storelocator.openingHour' | translate"
          [titleHidden]="false"
          class="c__toggle-hours"
          [icon]="isCardOpened? 'icon-arrow-up' : 'icon-arrow-down'"
          [size]="iconSize.small"
          [attr.aria-expanded]="isCardOpened"
        ></button>

        <div class="c__opening-infos" #hidePickup>
          <p class="c__opening-title is-caption is-bold">
            {{'storelocator.openingHour' | translate}}
          </p>
          <ul class="c__store-opening" sd-list-block>
            @for (opening of storeInfo?.openingHours; track opening) {
              <li class="is-caption">
                <ng-container *ngTemplateOutlet="openingHours; context: { $implicit: opening }" />
              </li>
            }
          </ul>
        </div>
      }
    </address>

      @if (repairCenter && !hideActions && isMobile$) {
        <button sd-button
          [brand]="brand"
          ngClass="c__choose-relay"
          (click)="selectRepairCenter()"
          [isSmall]="isMobile$"
        >
          {{ 'storelocator.repairer.actions.choose' | translate }}
        </button>
      }
    @if (storeInfo?.id === selectedPickupId) {
      <wc-relay-point-recap [store]="storeInfo" />
    } @else if (pickup) {
      <button sd-button
              [brand]="brand"
              ngClass="c__choose-relay"
              (click)="chooseStore()"
              [isSmall]="isMobile$">
        {{ buttonText | translate }}
      </button>
    }
  </div>

  @if (!pickup) {
      <button sd-button-icon
        #actionNonPickup
        type="button"
        [brand]="brand"
        [attr.aria-describedby]="'titleCard' + idCard"
        [attr.aria-controls]="isCardOpened"
        [buttonIconTitle]="(isCardOpened ? 'actions.less' : 'actions.more') | translate"
        [titleHidden]="false"
        [class]="isCardOpened ? 'c__toggle-card' : 'c__toggle-card is-full-area'"
        [icon]="isCardOpened? 'icon-arrow-up' : 'icon-arrow-right'"
        [size]="iconSize.small"
        [attr.aria-expanded]="isCardOpened"
      ></button>
      <div class="c__infos" #hideNonPickup [tabindex]="-1">
        <div class="c__contact">
          @if (storeInfo?.url) {
            <sd-link
              [link]="{url: storeInfo?.url, external: true}"
              class="c__website"
              [brand]="brand"
            >
              <sd-icon name="icon-web" [size]="iconSize.small" />
              <span class="is-caption">{{"storelocator.store.info.website" | translate}}</span>
            </sd-link>
          }
          @if (storeInfo?.telephone || storeInfo?.mail) {
            <p>
              @if (storeInfo?.telephone) {
                <span class="c__telephone is-caption">
                  <a [href]="'tel:' + storeInfo?.telephone">
                    <sd-icon name="icon-phone" [size]="iconSize.small" />
                    <span class="is-caption">{{storeInfo?.telephone}}</span>
                  </a>
                </span>
              }
              @if (storeInfo?.mail) {
                @for (mail of storeInfo.mail; track mail) {
                  <span class="c__mail">
                    <a [href]="'mailto:' + mail">
                      <sd-icon name="icon-mail" [size]="iconSize.small" />
                      <span class="is-caption">{{mail}}</span>
                    </a>
                  </span>
                }
              }
            </p>
          }
        </div>

      @if ((!pickup && storeInfo?.openingHours) || storeInfo?.openingNotes) {
        <div class="c__opening-infos">
          <p class="c__opening-title is-caption is-bold">
            {{'storelocator.openingHour' | translate}}
          </p>
          @if (!pickup && storeInfo?.openingHours) {
            <ul class="c__store-opening is-caption" sd-list-block>
              @for (opening of storeInfo?.openingHours; track opening) {
                <li class="is-caption">
                  <ng-container *ngTemplateOutlet="openingHours; context: { $implicit: opening }" />
                </li>
              }
            </ul>
          }
          @if (storeInfo?.openingNotes) {
            <p class="c__opening-notes is-caption is-bold" [attr.data-color]="'error-base'">
              {{storeInfo?.openingNotes}}
            </p>
          }
        </div>
      }

      @if (storeInfo?.services?.length || storeInfo?.info || itinaryUrl || (repairCenter && !hideActions && !isMobile$)) {
        <div class="c__service-details">
          @if (storeInfo?.services?.length > 0 && repairCenter) {
            <ul class="is-m" [alignement]="positionEnum.top" sd-list-inline>
              @for (service of storeInfo?.services; track service) {
                <li class="c__detail {{service.icon ? '': 'is-wysiwyg'}}">
                  <p class="c__services-title is-caption is-bold">
                    {{service?.label}}
                  </p>
                  @if (service?.details?.length) {
                    <ul sd-list-block>
                      @for (detail of service?.details; track detail) {
                        <li class="c__service">
                          @if (service?.icon) {
                            <sd-icon
                              [size]="iconSize.xs"
                              [attr.data-color]="service?.icon === 'icon-check' ? 'success-base' : 'error-base'"
                              [name]="service?.icon ? service?.icon : 'icon-circle-filled'"
                            />
                          }
                          <sd-html
                            [innerClass]="isMobile$ ? 'is-caption is-wysiwyg' : 'is-wysiwyg'"
                            [html]="detail"
                            tag="span"
                          />
                        </li>
                      }
                    </ul>
                  }
                  @if (service?.link) {
                    <sd-link
                      [brand]="brand"
                      [isButton]="true"
                      [isSecondary]="true"
                      [isSmall]="true"
                      [link]="service?.link"
                      (clicked)="learnMoreClick()"
                    >
                      {{service?.link?.linkName}}
                    </sd-link>
                  }
                </li>
              }
            </ul>
          }
          @if (storeInfo?.info) {
            <p class="c__global-info is-caption is-bold">
              {{storeInfo?.info}}
            </p>
          }
        </div>
      }

      @if (itinaryUrl || (repairCenter && !hideActions && !isMobile$)) {
        <ul class="c__card-actions" sd-list-inline>
          <li>
            @if (itinaryUrl) {
              <a sd-button
                [brand]="brand"
                target="_blank"
                [isSmall]="isMobile$"
                [isSecondary]="repairCenter && !isMobile$"
                (click)="itenaryClick()"
                [href]="itinaryUrl"
              >
                {{"storelocator.itinerary" | translate}}
              </a>
            }
          </li>
          <li>
            @if (repairCenter && !hideActions && !isMobile$) {
              <button sd-button
                [brand]="brand"
                (click)="selectRepairCenter()"
                [isSmall]="isMobile$"
              >
                {{ 'storelocator.repairer.actions.choose' | translate }}
              </button>
            }
          </li>
        </ul>
      }
    </div>
  }
</div>

<ng-template #openingHours let-opening>
  @if (!opening?.closed) {
    <span>{{ opening?.weekDay ? opening?.weekDay : '-' }}</span>
    @for (openingInterval of opening?.availability; track openingInterval) {
      <span class="is-bold is-caption">
        {{ openingInterval.openingTime?.formattedHour ? openingInterval.openingTime?.formattedHour : '  ' }}
        - {{ openingInterval.closingTime?.formattedHour ? openingInterval.closingTime?.formattedHour : '  ' }}
      </span>
    }
  }

  @if (opening?.closed) {
    <span>{{ opening?.weekDay ? opening?.weekDay : '-' }}</span>
    <span class="is-bold" [attr.data-color]="'error-base'">
      {{ 'storelocator.store.close' | translate }}
    </span>
  }
</ng-template>
